import {ManagerComponent} from './manager.component';
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ManagerGuard implements CanDeactivate<ManagerComponent> {

  canDeactivate(component: ManagerComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    console.log('ManagerGuard GO TO ->', nextState);
    if (!confirm('You could be lost input data! Are you sure to leave this page?')) {
      return false;
    } else {
      if (nextState.url === '/auth/login') {
        console.log('localStorage access_token, access_token_expires_at clear');
        localStorage.removeItem('access_token');
        localStorage.removeItem('access_token_expires_at');
      }
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/manager/manager.guard.ts